import { render, staticRenderFns } from "./GeneralAnnouncement.vue?vue&type=template&id=6773185c&scoped=true&"
import script from "./GeneralAnnouncement.vue?vue&type=script&lang=js&"
export * from "./GeneralAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./GeneralAnnouncement.vue?vue&type=style&index=0&id=6773185c&lang=scss&scoped=true&"
import style1 from "./GeneralAnnouncement.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6773185c",
  null
  
)

export default component.exports